import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  HeadTableCell,
  RowTableCell,
  CustomButton,
  DialogBody,
  SearchBar,
  GeneralTableBox,
  PaginationTable,
  ActionIconButton,
} from '../../../common/';

import PostAddIcon from '@mui/icons-material/PostAdd';

import PaymentMethodDialog from '../dialogs/PaymentMethodDialog';
import { usePaginatedFilter } from '../../../common/hooks/usePaginatedFilter';

const ITEMS_PER_PAGE = 5;

const filterPaymentMethods = (collection = [], term = '') => {
  if (!term?.trim()) return collection;
  const normalized = term.toLowerCase().trim();
  return collection.filter((method) => method.name?.toLowerCase().includes(normalized));
};

const PaymentMethodsTab = ({
  data,
  selectedItem,
  dialogOpen,
  editMode,
  handleAdd,
  handleEdit,
  handleDelete,
  handleClose,
  handleSave,
}) => {
  const {
    data: paginatedPaymentMethods,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
  } = usePaginatedFilter({
    data,
    itemsPerPage: ITEMS_PER_PAGE,
    filterFn: filterPaymentMethods,
  });

  return (
    <DialogBody sx={{ p: 2, minHeight: '65vh' }}>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <CustomButton variant="contained" onClick={handleAdd}>
            <PostAddIcon sx={{ mr: 1 }} />
            Agregar
          </CustomButton>
          <SearchBar onSearch={handleSearch} />
        </Box>
        <GeneralTableBox>
          <Table>
            <TableHead>
              <TableRow>
                <HeadTableCell>Nombre</HeadTableCell>
                <HeadTableCell>Fecha baja</HeadTableCell>
                <HeadTableCell>Acciones</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedPaymentMethods.map((paymentMethod, index) => (
                <TableRow key={paymentMethod.id || index}>
                  <RowTableCell>{paymentMethod.name}</RowTableCell>
                  <RowTableCell>{paymentMethod.low_date}</RowTableCell>
                  <RowTableCell>
                    <ActionIconButton variant="edit" onClick={() => handleEdit(paymentMethod)} />
                    <ActionIconButton
                      variant="delete"
                      onClick={() => handleDelete(paymentMethod.uuid)}
                    />
                  </RowTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {totalCount > rowsPerPage && (
            <PaginationTable
              totalPages={totalPages}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              totalCount={totalCount}
            />
          )}
        </GeneralTableBox>
      </Box>

      <PaymentMethodDialog
        open={dialogOpen}
        onClose={handleClose}
        onSave={handleSave}
        selectedItem={selectedItem}
        editMode={editMode}
      />
    </DialogBody>
  );
};

export default PaymentMethodsTab;
